<template>
<div class="back unselectable" v-on:click="click">
    <div class="iconbutton">
        <i :class="icon || 'fas fa-angle-left'"></i>
    </div>
</div>
</template>

<script>
export default {
    name: "backButton",
    props: {
        icon: String,
        action: {
            type: String,
            default: "/",
        },
        caption: {
            type: String,
            default: "",
        }
    },
    methods: {
        click: function () {

            

            if(!this.action){
                this.$emit('click')
                return
            }
            
            if (this.action == "back") {

                const history = this.$router.internalHistory || []

                if (history.length > 0) {
                    this.$router.go(-1)
                } else {
                    this.$router.push('/')
                }
                
            } else {
				this.$router.push(this.action).catch(e => {});
			}
        },
    },
};
</script>

<style scoped lang="sass">
.back
	cursor: pointer
.back-icon
	cursor: pointer
	.backbutton-caption
		cursor: pointer
		position: relative
		left: 2 * $r
</style>
